<div class="card-link mt-2 mx-auto ">
    <a class="card-preview-image">
        <img [src]="gifPreview.url"
             [alt]="gifPreview.name" />
    </a>
</div>
